import { render, staticRenderFns } from "./CascaderItem.vue?vue&type=template&id=d2d213da&scoped=true&"
import script from "./CascaderItem.vue?vue&type=script&lang=js&"
export * from "./CascaderItem.vue?vue&type=script&lang=js&"
import style0 from "./CascaderItem.vue?vue&type=style&index=0&id=d2d213da&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d213da",
  null
  
)

export default component.exports